<template>
  <v-container>
    <v-layout>
      <v-data-table
        dense
        :headers="headers"
        :items="list"
        sort-by="email"
        v-model="selected"
        show-select
      >
        <template v-slot:items="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td>
              <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
            </td>
            <td>{{props.item}}</td>
            <td>{{ props.item.fname }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.roles }}</td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary">Reset</v-btn>
        </template>
      </v-data-table>
    </v-layout>
    <v-layout row wrap>
      <v-flex pa-5 xs12 md4>
        <h1># Items Selected : {{selected.length}}</h1>

        <v-dialog v-model="addUser" persistent max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on">Add User</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Add User</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field label="First name" v-model="fname" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field label="Email" required v-model="email"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field label="Password*" type="password" v-model="password" required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="addUser = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="signup">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-form ref="form">
          <v-btn flat class="success mx-0 mt-3" @click="promote" :loading="loading">Make Admin</v-btn>
          <v-btn flat class="success mx-0 mt-3" @click="reset" :loading="loading">Reset Password</v-btn>
          <v-btn
            flat
            class="success mx-0 mt-3"
            @click="demote"
            :loading="loading"
          >Remove Permissions</v-btn>
          <v-btn flat class="success mx-0 mt-3" @click="demoteAdmin" :loading="loading">Remove Admin</v-btn>
          <v-btn
            flat
            class="success mx-0 mt-3"
            @click="allowUpstairs"
            :loading="loading"
          >promote upstairs</v-btn>

          <v-btn flat class="success mx-0 mt-3" @click="remove" :loading="loading">Delete User</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import db from "@/fb";
import firebase from "firebase";

export default {
  data: () => ({
    isMobile: false,
    dialog: false,
    addUser: false,
    toFactory: false,
    loading: false,
    fname: "",
    email: "",
    password: "",
    selected: [],
    list: [],
    headers: [
      {
        text: "Name",
        align: "left",
        value: "fname",
        sortable: false
      },
      { text: "email", align: "center", value: "customer", sortable: false },
      { text: "roles", align: "center", value: "customer", sortable: false }
    ]
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },
  mounted() {},
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    db.collection("users").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.list.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
  },

  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.list.slice();
    },
    signup() {
      const user = {
        email: this.email,
        password: this.password
      };
      const entry = {
        email: this.email,
        fname: this.fname,
        roles: { upstairs: false, factory: true }
      };
      this.$store.dispatch("signUpAction", user);

      db.collection("users")
        .add(entry)
        .then(() => {
          this.loading = false;
          this.$emit("userCreated");
          this.addUser = false;
        });
    },
    reset() {
      var auth = firebase.auth();
      for (var i = 0; i < this.selected.length; i++) {
        auth
          .sendPasswordResetEmail(this.selected[i].email)
          .then(function() {
            // Email sent.
            alert("Reset Password sent to user email");
          })
          .catch(function(error) {
            // An error happened.
            alert("Error! +", error);
          });
      }
    },
    promote() {
      for (var i = 0; i < this.selected.length; i++) {
        db.collection("users")
          .doc(this.selected[i].id)
          .update({
            "roles.admin": true,
            "roles.factory": true,
            "roles.upstairs": true
          })
          .then(() => {
            this.$emit("invoice");
          });
      }
    },
    allowUpstairs() {
      for (var i = 0; i < this.selected.length; i++) {
        db.collection("users")
          .doc(this.selected[i].id)
          .update({
            "roles.upstairs": true
          })
          .then(() => {
            this.$emit("invoice");
          });
      }
    },
    demoteAdmin() {
      for (var i = 0; i < this.selected.length; i++) {
        db.collection("users")
          .doc(this.selected[i].id)
          .update({
            "roles.admin": false,
            "roles.factory": true,
            "roles.upstairs": true
          })
          .then(() => {
            this.$emit("invoice");
          });
      }
    },
    demote() {
      for (var i = 0; i < this.selected.length; i++) {
        db.collection("users")
          .doc(this.selected[i].id)
          .update({
            "roles.admin": false,
            "roles.factory": true,
            "roles.upstairs": false
          })
          .then(() => {
            this.$emit("invoice");
          });
      }
    },
    remove() {
      for (var i = 0; i < this.selected.length; i++) {
        db.collection("users")
          .doc(this.selected[i].id)
          .delete()
          .then(() => {
            this.$emit("removed");
          });
      }
    }
  }
};
</script>

<style>
</style>
